import {
  ADD_CUSTOMER_START,
  ADD_CUSTOMER_SUCCESS,
  ADD_CUSTOMER_FAILURE,
  ADD_CUSTOMER_RESET,
  GET_CUSTOMER_START,
  GET_CUSTOMER_SUCCESS,
  GET_CUSTOMER_FAILURE,
  GET_CUSTOMER_RESET,
  DELETE_CUSTOMER_START,
  DELETE_CUSTOMER_SUCCESS,
  DELETE_CUSTOMER_FAILURE,
  DELETE_CUSTOMER_RESET,
  EDIT_CUSTOMER_START,
  EDIT_CUSTOMER_SUCCESS,
  EDIT_CUSTOMER_RESET,
  EDIT_CUSTOMER_FAILURE,
  VIEW_CUSTOMER_START,
  VIEW_CUSTOMER_SUCCESS,
  VIEW_CUSTOMER_FAILURE,
  VIEW_CUSTOMER_RESET,
  GET_CUSTOMER_TYPE_FAILURE,
  GET_CUSTOMER_TYPE_RESET,
  GET_CUSTOMER_TYPE_START,
  GET_CUSTOMER_TYPE_SUCCESS,
  ADD_CUSTOMER_FOLLOWUP_START,
  ADD_CUSTOMER_FOLLOWUP_SUCCESS,
  ADD_CUSTOMER_FOLLOWUP_FAILURE,
  ADD_CUSTOMER_FOLLOWUP_RESET,
  GET_CUSTOMER_FOLLOWUP_START,
  GET_CUSTOMER_FOLLOWUP_SUCCESS,
  GET_CUSTOMER_FOLLOWUP_FAILURE,
  GET_CUSTOMER_FOLLOWUP_RESET,
  GET_CUSTOMER_PROFILE_START,
  GET_CUSTOMER_PROFILE_SUCCESS,
  GET_CUSTOMER_PROFILE_FAILURE,
  GET_CUSTOMER_PROFILE_RESET,
  UPDATE_CUSTOMER_PROFILE_START,
  UPDATE_CUSTOMER_PROFILE_SUCCESS,
  UPDATE_CUSTOMER_PROFILE_FAILURE,
  UPDATE_CUSTOMER_PROFILE_RESET,
  CUSTOMER_ID_RESET,
  GET_CUSTOMER_NAME_SUCCESS,
  GET_CUSTOMER_NAME_RESET,
  UPLOAD_FILE_START,
  UPLOAD_FILE_SUCCESS,
  UPLOAD_FILE_FAIL,
  GET_UPLOADED_FILE_RESET,
  GET_UPLOADED_FILE_START,
  GET_UPLOADED_FILE_SUCCESS,
  GET_UPLOADED_FILE_FAILURE,
  CREATE_UPLOAD_LINK_START,
  CREATE_UPLOAD_LINK_SUCCESS,
  CREATE_UPLOAD_LINK_FAIL,
  UPOLOAD_FILE_LINK_START,
  UPOLOAD_FILE_LINK_SUCCESS,
  CUST_VIEWFILE_START,
  CUST_VIEWFILE_SUCCESS,
  CUST_VIEWFILE_FAIL,
  DELETE_FILE_FAILURE,
  DELETE_FILE_SUCCESS,
  DELETE_FILE_START,
  DELETE_FILE_RESET,
  GET_BLOCKED_CUST,
  GET_BLOCKED_CUST_SUCCESS,
  GET_BLOCKED_CUST_FAILED,
  EDIT_CUST_FILES,
  EDIT_CUST_FILES_SUCCESS,
  EDIT_CUST_FILES_FAILED,
} from "./actiontypes"

const initialState = {
  Customers: [],
  error: null,
  AddCustomerLoading: false,
  SingleCustomer: [],
  id: "",
  CustomerName: [],
  CustomerType: [],
  CustomerMsg: "",
  deleteCustomer: false,
  deleteCustomerMsg: "",
  editCustLoading: false,
  CustomerLogMsg: "",
  customerFollouwp: [],
  customerFamilyDetails: [],
  Loading: false,
  uploadedFiles: [],
  deleteFile: false,
  isUploading: false,
  uploadFileLink: "",
  blockedCustList: []
}

const CustomerReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_CUSTOMER_START:
      return {
        ...state,
        AddCustomerLoading: true,
        error: null,
        CustomerMsg: "",
        CustomerLogMsg: "",
      }
    case ADD_CUSTOMER_SUCCESS:
      return {
        ...state,
        CustomerMsg: action.payload.message,
        id: action.payload.customer_id,
        AddCustomerLoading: false,
      }

    case GET_CUSTOMER_NAME_SUCCESS: {
      return {
        ...state,
        CustomerName: action.payload.data[0].customer,
      }
    }

    case ADD_CUSTOMER_FAILURE:
      return {
        ...state,
        error: action.payload.message,
        AddCustomerLoading: false,
      }

    case ADD_CUSTOMER_RESET:
      return {
        Customers: [],
        error: null,
        AddCustomerLoading: false,
        CustomerMsg: "",
      }

    case GET_CUSTOMER_TYPE_SUCCESS:
      return {
        ...state,
        CustomerType: action.payload,
      }

    case GET_CUSTOMER_TYPE_RESET:
      return {
        ...state,
        CustomerType: [],
      }

    case GET_CUSTOMER_START:
      return {
        ...state,
        AddCustomerLoading: true,
        error: null,
        CustomerMsg: "",
        CustomerLogMsg: "",
      }

    case CUSTOMER_ID_RESET:
      return {
        ...state,
        id: "",
      }

    case GET_CUSTOMER_SUCCESS:
      //console.log(action.payload.data)
      return {
        ...state,
        AddCustomerLoading: false,
        Customers: action.payload.data,
        // CustomerMsg: action.payload.message,
      }

    case GET_CUSTOMER_FAILURE:
      return {
        ...state,
        AddCustomerLoading: false,
        error: action.payload.message,
      }
    case GET_CUSTOMER_RESET:
      return {
        Customers: [],
        error: null,
        AddCustomerLoading: false,
      }

    case GET_CUSTOMER_NAME_RESET:
      return {
        ...state,
        CustomerName: [],
      }
    // for delete

    case DELETE_CUSTOMER_START:
      return {
        ...state,
        deleteCustomer: false,
        error: null,
        CustomerMsg: "",
      }
    case DELETE_CUSTOMER_SUCCESS:
      return {
        ...state,
        deleteCustomer: true,
        error: null,
        CustomerMsg: action.payload.message,
      }
    case DELETE_CUSTOMER_FAILURE:
      return {
        ...state,
        deleteCustomer: false,
        error: action.payload.message,
      }
    case DELETE_CUSTOMER_RESET:
      return {
        Customers: [],
        ...state,
        deleteCustomer: false,
        error: null,
        CustomerMsg: "",
      }

    // edit lead

    case EDIT_CUSTOMER_START:
      return {
        ...state,
        error: null,
        editCustLoading: true,
        CustomerMsg: "",
      }

    case EDIT_CUSTOMER_SUCCESS:
      return {
        ...state,
        error: null,
        editCustLoading: false,
        CustomerMsg: action.payload.message,
      }

    case EDIT_CUSTOMER_FAILURE:
      return {
        ...state,
        editCustLoading: false,
        error: action.payload.message,
      }
    case EDIT_CUSTOMER_RESET:
      return {
        error: null,
        AddCustomerLoading: false,
        CustomerMsg: "",
        deleteCustomer: false,
        deleteCustomerMsg: "",
        editCustLoading: false,
      }

    // Get Single Customer for admin
    case VIEW_CUSTOMER_START:
      return {
        ...state,
        AddCustomerLoading: true,
        error: null,
        CustomerMsg: "",
      }

    case VIEW_CUSTOMER_SUCCESS:
      return {
        ...state,
        AddCustomerLoading: false,
        SingleCustomer: action.payload.data,
      }

    case VIEW_CUSTOMER_FAILURE:
      return {
        ...state,
        AddCustomerLoading: false,
        error: action.payload.message,
        CustomerMsg: "",
      }

    case VIEW_CUSTOMER_RESET:
      return {
        SingleCustomer: [],
        error: null,
        AddCustomerLoading: false,
        CustomerMsg: "",
      }

    case ADD_CUSTOMER_FOLLOWUP_START:
      return {
        ...state,
        AddCustomerLoading: true,
        error: null,
        CustomerLogMsg: "",
      }
    case ADD_CUSTOMER_FOLLOWUP_SUCCESS:
      return {
        ...state,
        CustomerLogMsg: action.payload.message,
        AddCustomerLoading: false,
      }

    case ADD_CUSTOMER_FOLLOWUP_FAILURE:
      return {
        ...state,
        error: action.payload.message,
        AddCustomerLoading: false,
      }
    case ADD_CUSTOMER_FOLLOWUP_RESET:
      return {
        ...state,
        error: null,
        AddCustomerLoading: false,
        CustomerLogMsg: "",
      }

    case GET_CUSTOMER_FOLLOWUP_START:
      return {
        ...state,
        AddCustomerLoading: true,
        error: null,
        customerFollouwp: [],
      }
    case GET_CUSTOMER_FOLLOWUP_SUCCESS:
      return {
        ...state,
        customerFollouwp: action.payload.data,
        AddCustomerLoading: false,
      }

    case GET_CUSTOMER_FOLLOWUP_FAILURE:
      return {
        ...state,
        error: action.payload.message,
        AddCustomerLoading: false,
      }
    case GET_CUSTOMER_FOLLOWUP_RESET:
      return {
        ...state,
        error: null,
        AddCustomerLoading: false,
        customerFollouwp: [],
      }

    case GET_CUSTOMER_PROFILE_START:
      return {
        ...state,
        AddCustomerLoading: true,
        error: null,
        CustomerMsg: "",
      }

    case GET_CUSTOMER_PROFILE_SUCCESS:
      //console.log(action.payload.data)
      return {
        ...state,
        AddCustomerLoading: false,
        customerFamilyDetails: action.payload.data,
        // CustomerMsg: action.payload.message,
      }

    case GET_CUSTOMER_PROFILE_FAILURE:
      return {
        ...state,
        AddCustomerLoading: false,
        error: action.payload.message,
      }
    case GET_CUSTOMER_FOLLOWUP_RESET:
      return {
        ...state,
        customerFamilyDetails: [],
        error: null,
        AddCustomerLoading: false,
      }

    case UPDATE_CUSTOMER_PROFILE_START:
      return {
        ...state,
        AddCustomerLoading: true,
        error: null,
        CustomerMsg: "",
      }

    case UPDATE_CUSTOMER_PROFILE_SUCCESS:
      //console.log(action.payload.data)
      return {
        ...state,
        AddCustomerLoading: false,
        CustomerMsg: action.payload.message,
      }

    case UPDATE_CUSTOMER_PROFILE_FAILURE:
      return {
        ...state,
        AddCustomerLoading: false,
        error: action.payload.message,
      }
    case UPDATE_CUSTOMER_PROFILE_RESET:
      return {
        ...state,
        error: null,
        AddCustomerLoading: false,
      }
    case UPLOAD_FILE_START:
      return {
        ...state,
        Loading: true,
        error: null,
        CustomerMsg: null,
        isUploading: false,
      }
    case UPLOAD_FILE_SUCCESS:
      return {
        ...state,
        Loading: false,
        CustomerMsg: action.payload,
        isUploading: true,
      }
    case UPLOAD_FILE_FAIL:
      return {
        ...state,
        Loading: false,
        isUploading: false,

        error: action.payload,
      }
    case GET_UPLOADED_FILE_START:
      return {
        ...state,
        Loading: true,
        error: null,
        CustomerMsg: null,
        uploadedFiles: [],
      }
    case GET_UPLOADED_FILE_SUCCESS:
      return {
        ...state,
        Loading: false,
        uploadedFiles: action.payload,
      }
    case GET_UPLOADED_FILE_FAILURE:
      return {
        ...state,
        Loading: false,
        error: action.payload,
      }
    case GET_UPLOADED_FILE_RESET:
      return {
        ...state,
        Loading: false,
        error: null,
        CustomerMsg: null,
      }
    case CREATE_UPLOAD_LINK_START:
      return {
        ...state,
        Loading: true,
        error: null,
        uploadFileLink: "",
      }
    case CREATE_UPLOAD_LINK_SUCCESS:
      return {
        ...state,
        Loading: false,
        uploadFileLink: action.payload.hashkey,
      }
    case CREATE_UPLOAD_LINK_FAIL:
      return {
        ...state,
        Loading: false,
        error: action.payload,
      }
    case UPOLOAD_FILE_LINK_START:
      return {
        ...state,
        Loading: true,
        CustomerMsg: "",
        error: null,
      }
    case UPOLOAD_FILE_LINK_SUCCESS:
      return {
        ...state,
        Loading: false,
        CustomerMsg: "File Uploaded SuccessFully",
      }
    case UPLOAD_FILE_FAIL:
      return {
        ...state,
        Loading: false,
        error: "unable to upload file, please try again",
      }

    case EDIT_CUST_FILES:
      return {
        ...state,
        Loading: true,
        CustomerMsg: "",
        error: null,
      }
    case EDIT_CUST_FILES_SUCCESS:
      return {
        ...state,
        Loading: false,
        CustomerMsg: "File Edited SuccessFully",
      }
    case EDIT_CUST_FILES_FAILED:
      return {
        ...state,
        Loading: false,
        error: "unable to EDIT file, please try again",
      }
    case CUST_VIEWFILE_START:
      return {
        ...state,
        Loading: true,
        CustomerMsg: "",
        error: "",
        uploadedFiles: [],
      }
    case CUST_VIEWFILE_START:
      return {
        ...state,
        Loading: true,
        error: null
      }

    case CUST_VIEWFILE_SUCCESS:
      return {
        ...state,
        Loading: false,
        uploadedFiles: action.payload,
      }
    case CUST_VIEWFILE_FAIL:
      return {
        ...state,
        Loading: false,
        error: action.payload,
      }

    case DELETE_FILE_START:
      return {
        ...state,
        Loading: true,
        deleteFile: true,

      }
    case DELETE_FILE_SUCCESS:
      return {
        ...state,
        Loading: false,
        deleteFile: true,
      }
    case DELETE_FILE_FAILURE:
      return {
        ...state,
        Loading: false,
        deleteFile: false,
      }
    case DELETE_FILE_RESET:
      return {
        ...state,
        Loading: false,
        deleteFile: false,
      }

    case GET_BLOCKED_CUST:
      return {
        ...state,
        Loading: true
      }
    case GET_BLOCKED_CUST_SUCCESS:
      return {
        ...state,
        blockedCustList: action.payload,
        Loading: false,
      }
    case GET_BLOCKED_CUST_FAILED:
      return {
        ...state,
        Loading: false,
        error: action.payload
      }
    default:
      return state
  }
}

export default CustomerReducer
